// Analogue of src/dany-one/src/vendor.js but for chromecast

/* global global */

// CONVIVA
global.Conviva = require('./vendor/conviva/conviva-core-sdk.js');
// The additional lib Conviva SDK Chromecast CAF doesn't load from this location.
// We are getting an integration error: Include the missing Player Module
// Instead of this we decided to add the import into index.html
//require('./vendor/conviva/conviva-chromecast-cafmodule.js');

// COMSCORE
global.ns_ = require('./vendor/comscore.js'); // 7.3.0.200309
// NIELSEN
// Script loaded in appendNielsen method in App.js module
